import * as yup from 'yup';

export const commonBillToCompanyMappingValidation: { [x: string]: any; } = {
    billToCompanyCode: yup.string().required("Missing."),
    activeInd: yup.string().required("Missing."),
};

export const createBillToCompanyMappingValidation: { [x: string]: any; } = {
    ...commonBillToCompanyMappingValidation,
};

export const createBillToCompanyMappingValidationSchema = yup.object().shape(createBillToCompanyMappingValidation);

